import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=76e8d08b&scoped=true&"
import script from "./Changelog.vue?vue&type=script&lang=js&"
export * from "./Changelog.vue?vue&type=script&lang=js&"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=76e8d08b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e8d08b",
  null
  
)

export default component.exports